import { Auth } from 'aws-amplify';
import { OAuth } from "../../utils/oauth";
import { history } from '../../utils';
import { handler } from '../../components/cognito/decode-verify-jwt';

const state = {
    accessKey: '',
    isValidToken: false
};

export const LogoutToken = () => {
    let params = new URLSearchParams(history.location.search);
    state.accessKey = params.get('access_token');    
    let localToken = Auth.currentSession();
  
    // Fix: Pass the token in the correct format
    let handlerToken = handler({ token: state.accessKey });
    
    // Fix: Use Promise.all to wait for both async operations
    Promise.all([handlerToken, localToken]).then(([handlerResult, sessionData]) => {
        state.isValidToken = handlerResult.isValid;
        
        // Fix: More explicit logic for when to logout
        const shouldLogout = (
            state.accessKey != null && 
            state.accessKey === sessionData.getAccessToken().getJwtToken()
        ) || state.isValidToken;
        
        if (shouldLogout) {
            OAuth.logout();
        }
    }).catch(error => {
        console.error('Error during logout token validation:', error);
        // Still proceed with logout if there's an error
        OAuth.logout();
    });
};